import { CommandCenterSectionModel } from "./CommandCenterSection.model";

export class CommandCenterSection extends CommandCenterSectionModel {
    // Add custom methods here
}
